/* Every word the Loupe hero shows. The headline is set on one line and sized
 * to fill the width, so any length works; the footer credits have to fit a
 * 280px phone once the "In support of" label drops away. */

/* Non-breaking spaces around the dot: plain spaces collapse inside SVG text,
 * and these pad two passes of the phrase out to close the ring on the disc. */
const RING_GAP = "   ·   "

export const COPY = {
    brand: "Loupe",
    brandSub: "Type & Optics",
    meta: ["Glass over type", "One held frame", "Autumn 2026"],
    cta: "Look closer",
    disc: `SEE THE WORK${RING_GAP}SEE THE WORK${RING_GAP}`,
    discLabel: "See the work",
    headline: "Discovery",
    footLeft: "© 2026 Loupe",
    footRight: "In support of",
    footRightName: "Slow reading"
}
